import axios from "axios";
import { servicePath } from "../../utility/data";

export const getTransaction = async (
  assetId,
  typeId,
  skip,
  limit,
  filterType,
  accessToken
) => {
  try {
    const response = await axios.get(
      `${servicePath}/transaction?asset_id=${assetId}&type_id=${typeId}&skip=${
        skip ? skip : 0
      }&limit=${limit ? limit : 10}&filter=${filterType ? filterType : "All"}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getFutureTransaction = async (
  assetId,
  skip,
  limit,
  filterType,
  type_id,
  accessToken
) => {
  try {
    const response = await axios.get(
      `${servicePath}/transaction/future_transactions?asset_id=${assetId}&type_id=${type_id}&skip=${
        skip ? skip : 0
      }&limit=${limit ? limit : 10}&filter=${filterType ? filterType : "All"}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getUserAssets = async (assetTypeId, accessToken) => {
  try {
    const response = await axios.get(
      `${servicePath}/asset/get-user-assets?asset_type=${assetTypeId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const addTransaction = async (
  transactionData,
  assetName,
  accessToken
) => {
  const payload = {
    assetTypeId: transactionData.assetType.id,
    assetId: assetName.id,
    group_id: transactionData?.includeIn?.id,
    date: transactionData.date,
    type: transactionData.type,
    multiples: transactionData.multiples ? transactionData.multiples : null,
    currency: transactionData.currency,
    amount: transactionData.amount ? transactionData.amount : 0,
    reason: transactionData.reason,
    ebitda: transactionData.EBITDA ? transactionData.EBITDA : null,
    noi: transactionData.noi ? transactionData.noi : null,
    cap_rate: transactionData.capRate ? transactionData.capRate : null,
    quantity: transactionData.quantity ? transactionData.quantity : null,
    cost_price: transactionData.costPrice ? transactionData.costPrice : null,
    remark: transactionData.reason,
    value: transactionData.value ? transactionData.value : null,
    p_and_l: transactionData.p_and_l ? transactionData.p_and_l : 0,
    isRecurring: transactionData.isRecurring
      ? transactionData.isRecurring
      : false,
    recurringDay: transactionData.recurringDay
      ? transactionData.recurringDay
      : null,
    cash_asset_id: transactionData.cashAssets
      ? transactionData.cashAssets
      : null,
  };

  try {
    const response = await axios.post(`${servicePath}/transaction`, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response;
  } catch (error) {
    console.error("Error :", error);
    throw error;
  }
};

export const additems = async (transactionData, assetName, accessToken) => {
  const payload = {
    name: transactionData.name,
    type: transactionData.itemType,
    initial_balance: transactionData.purchasePrice,
    date: transactionData.date,
    luxury_asset_id: assetName,
    legacy_id: transactionData.legacies.id,
  };

  try {
    const response = await axios.post(
      `${servicePath}/luxury-asset/add-item`,
      payload,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error :", error);
    throw error;
  }
};

export const updateTransaction = async (
  transaction_id,
  transactionData,
  assetName,
  accessToken
) => {
  const payload = {
    assetTypeId: transactionData.assetType.id,
    assetId: assetName.id,
    group_id: transactionData.includeIn.id,
    date: transactionData.date,
    type: transactionData.type,
    multiples: transactionData.multiples ? transactionData.multiples : null,
    currency: transactionData.currency,
    amount: transactionData.amount ? transactionData.amount : 0,
    reason: transactionData.reason,
    ebitda: transactionData.EBITDA ? transactionData.EBITDA : null,
    noi: transactionData.noi ? transactionData.noi : null,
    cap_rate: transactionData.capRate ? transactionData.capRate : null,
    quantity: transactionData.quantity ? transactionData.quantity : null,
    cost_price: transactionData.costPrice ? transactionData.costPrice : null,
    remark: transactionData.reason,
    value: transactionData.value ? transactionData.value : null,
    p_and_l: transactionData.p_and_l ? transactionData.p_and_l : null,
    isRecurring: transactionData.isRecurring
      ? transactionData.isRecurring
      : false,
    recurringDay: transactionData.recurringDay
      ? transactionData.recurringDay
      : null,
    cash_asset_id: transactionData.cashAssets
      ? transactionData.cashAssets
      : null,
  };

  try {
    const response = await axios.patch(
      `${servicePath}/transaction/${transaction_id}`,
      payload,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error :", error);
    throw error;
  }
};

export const deleteTransaction = async (accessToken, id) => {
  try {
    const response = await axios.delete(`${servicePath}/transaction/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteMediaService = async (accessToken, id) => {
  try {
    const response = await axios.delete(`${servicePath}/media/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const getStockTransaction = async (
  assetId,
  skip,
  limit,
  filterType,
  accessToken
) => {
  try {
    const response = await axios.get(
      `${servicePath}/transaction/stock?asset_id=${assetId}&skip=${
        skip ? skip : 0
      }&limit=${limit ? limit : 10}&filter=${
        filterType ? filterType.name : "All"
      }`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const addStockTransaction = async (
  transactionData,
  assetName,
  accessToken
) => {
  const payload = {
    assetTypeId: transactionData.assetType.id,
    assetId: assetName.id,
    group_id: transactionData.includeIn.id,
    date: transactionData.date,
    type: transactionData.type,
    currency: transactionData.currency,
    amount: transactionData.amount ? transactionData.amount : null,
    reason: transactionData.reason,
    noi: transactionData.noi ? transactionData.noi : null,
    cap_rate: transactionData.capRate ? transactionData.capRate : null,
    quantity: transactionData.quantity ? transactionData.quantity : null,
    cost_price: transactionData.costPrice ? transactionData.costPrice : null,
    remark: transactionData.reason,
  };

  try {
    const response = await axios.post(
      `${servicePath}/transaction/stock-transaction`,
      payload,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error :", error);
    throw error;
  }
};

export const getRoiService = async (symbol, accessToken) => {
  try {
    const response = await axios.get(
      `${servicePath}/stock/get-roi?stock_asset_id=${symbol}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const getCompanyprofileService = async (symbol, accessToken) => {
  try {
    const response = await axios.get(
      `${servicePath}/stock/company-profile?symbol=${symbol}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const getRoiRealEstateService = async (symbol, accessToken) => {
  try {
    const response = await axios.get(
      `${servicePath}/real-estate/get-valuation-graph?real_estate_id=${symbol}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const getRoiRealEstateMediaService = async (symbol, accessToken) => {
  try {
    const response = await axios.get(
      `${servicePath}/real-estate/get-medias?real_estate_id=${symbol}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const getRoiRealEstateStatsService = async (symbol, accessToken) => {
  try {
    const response = await axios.get(
      `${servicePath}/real-estate/get-stats?real_estate_id=${symbol}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const addMediaService = async (
  Media,
  related_id,
  asset_type,
  accessToken
) => {
  const formData = new FormData();

  if (Media.length > 0) {
    formData.append("file", Media[0].file);
  }

  try {
    const response = await axios.post(
      `${servicePath}/media?is_private=false&asset_type=${asset_type}&related_id=${related_id}`,
      formData,
      {
        headers: {
          Accept: "application/json",
          // 'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getPensionService = async (pension_id, accessToken) => {
  try {
    const response = await axios.get(`${servicePath}/pensions/${pension_id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const getPensionMediaService = async (
  asset_type,
  asset_type_id,
  accessToken
) => {
  try {
    const response = await axios.get(
      `${servicePath}/media?asset_type=${asset_type}&asset_type_id=${asset_type_id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};


export const updatelegacyNameService = async (
  selectedAsset,
  updatedLegacy,
  accessToken
) => {
  const payload = {
    name: selectedAsset?.name,
    asset_type_id: 4,
    asset_id: selectedAsset?.id,
    legacy_id: updatedLegacy.id,
  };

  try {
    const response = await axios.put(
      `${servicePath}/asset/update-asset`,
      payload,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error :", error);
    throw error;
  }
};